import { EquipmentType, Mode } from '@rygen/rygen-ui/model';

import { RateQuote } from '../rate/RateQuote';

import { LoadboardSource } from './LoadboardSource';
import { LoadboardStatus } from './LoadboardStatus';

export class Loadboard {
  id?: number;
  rateShopId?: number;
  status?: LoadboardStatus;
  source?: LoadboardSource;
  mode?: Mode;
  equipmentType?: EquipmentType;
  expiration?: Date;
  createdBy?: string;
  createdDate?: Date;
  bids?: RateQuote[];
  comments?: string;

  constructor(opts?: Partial<Loadboard>) {
    if (opts?.id) {
      this.id = opts.id;
    }
    if (opts?.rateShopId) {
      this.rateShopId = opts.rateShopId;
    }
    if (opts?.status) {
      this.status = opts.status;
    }
    if (opts?.source) {
      this.source = opts.source;
    }
    if (opts?.mode) {
      this.mode = opts.mode;
    }
    if (opts?.equipmentType) {
      this.equipmentType = new EquipmentType(opts.equipmentType);
    }
    if (opts?.expiration) {
      this.expiration = opts.expiration;
    }
    if (opts?.createdBy) {
      this.createdBy = opts.createdBy;
    }
    if (opts?.createdDate) {
      this.createdDate = opts.createdDate;
    }
    if (opts?.bids) {
      this.bids = opts.bids.map((bid) => new RateQuote(bid));
    }
    if (opts?.comments !== undefined) {
      this.comments = opts.comments;
    }
  }
}
